import { Component, OnInit } from "@angular/core";

@Component({
	selector: "app-view-section",
	templateUrl: "./view-section.component.html",
	styleUrls: ["./view-section.component.css"],
})
export class ViewSectionComponent implements OnInit {
	constructor() {}

	ngOnInit(): void {}

	/////////////////////////////////////////
	// Data
	/////////////////////////////////////////

	//Input Data (from selector)

	//Output Data
	CourseNumber: any = "N/A";
	SectionNumber: any = "N/A";
	CourseName: any = "N/A";
	Description: any = "N/A";
	Department: any = "N/A";

	SectionID: any = -1;
	SemesterID: any = -1;

	/////////////////////////////////////////

	/////////////////////////////////////////
	// Events
	/////////////////////////////////////////

	onSectionSelected(val) {
		if (val == null) {
			this.CourseNumber = "N/A";
			this.SectionNumber = "N/A";
			this.CourseName = "N/A";
			this.Description = "N/A";
			this.Department = "N/A";
			this.SectionID = -1;
			this.SemesterID = -1;
		} else {
			this.CourseNumber = val.CourseNo;
			this.SectionNumber = val.SectionNo;
			this.CourseName = val.CourseCD;
			this.Description = val.CourseCD;
			this.Department = val.DepartmentDesc;
			this.SectionID = val.SectionID;
			this.SemesterID = val.SemesterID;
		}
	}

	/////////////////////////////////////////
}
